<template>
  <div class="home">
  </div>
</template>

<script>
export default {
  name: 'Home',
  components: {
  },
  mounted() {
    window.location = 'https://www.wakatoon.com';
  }
}
</script>
